import React from 'react';
import { TouchableOpacity, View } from 'react-native';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import { createStackNavigator } from '@react-navigation/stack';
import { Ionicons } from '@expo/vector-icons';

// Placeholder Screens - werden später erstellt
import ShoppingScreen from '../screens/ShoppingScreen';
import QuickListScreen from '../screens/QuickListScreen';
import StoresScreen from '../screens/StoresScreen';
import ArticlesScreen from '../screens/ArticlesScreen';
import CollectionsScreen from '../screens/CollectionsScreen';
import CollectionDetailScreen from '../screens/CollectionDetailScreen';
import ProfileScreen from '../screens/ProfileScreen';

const Tab = createBottomTabNavigator();
const ShoppingStack = createStackNavigator();
const CollectionsStack = createStackNavigator();

// Shopping Stack Navigator
const ShoppingStackNavigator = () => {
  return (
    <ShoppingStack.Navigator
      screenOptions={{
        headerStyle: {
          backgroundColor: '#2E7D32',
        },
        headerTintColor: '#fff',
        headerTitleStyle: {
          fontWeight: 'bold',
        },
      }}
    >
      <ShoppingStack.Screen 
        name="ShoppingList" 
        component={ShoppingScreen}
        options={({ navigation }) => ({
          headerTitle: 'Einkaufslisten',
          headerRight: () => (
            <View style={{ flexDirection: 'row', alignItems: 'center', marginRight: 15 }}>
              <TouchableOpacity 
                onPress={() => {
                  // Suchfeld umschalten
                  navigation.setParams({ toggleSearch: true });
                }}
                style={{ marginRight: 15 }}
              >
                <Ionicons 
                  name="search-outline" 
                  size={24} 
                  color="#fff"
                />
              </TouchableOpacity>
              <TouchableOpacity 
                onPress={() => {
                  // Reload auslösen
                  navigation.setParams({ refresh: true });
                }}
                style={{ marginRight: 15 }}
              >
                <Ionicons 
                  name="refresh-outline" 
                  size={24} 
                  color="#fff"
                />
              </TouchableOpacity>
              <TouchableOpacity 
                onPress={() => navigation.navigate('QuickList')}
              >
                <Ionicons 
                  name="add-circle-outline" 
                  size={28} 
                  color="#fff"
                />
              </TouchableOpacity>
            </View>
          ),
        })}
      />
      <ShoppingStack.Screen 
        name="QuickList" 
        component={QuickListScreen}
        options={{
          headerTitle: 'Schnell-Liste',
        }}
      />
    </ShoppingStack.Navigator>
  );
};

// Collections Stack Navigator
const CollectionsStackNavigator = () => {
  return (
    <CollectionsStack.Navigator
      screenOptions={{
        headerStyle: {
          backgroundColor: '#2E7D32',
        },
        headerTintColor: '#fff',
        headerTitleStyle: {
          fontWeight: 'bold',
        },
      }}
    >
      <CollectionsStack.Screen 
        name="CollectionsList" 
        component={CollectionsScreen}
        options={({ navigation }) => ({
                   headerTitle: 'Körbe',
          headerRight: () => (
            <TouchableOpacity 
              onPress={() => {
                // Öffne das Modal zum Erstellen eines neuen Korbes
                navigation.setParams({ openCreateModal: true });
              }}
              style={{ marginRight: 15 }}
            >
              <Ionicons 
                name="add-circle-outline" 
                size={28} 
                color="#fff"
              />
            </TouchableOpacity>
          ),
        })}
      />
      <CollectionsStack.Screen 
        name="CollectionDetail" 
        component={CollectionDetailScreen}
        options={({ route }) => ({
          headerTitle: route.params?.collectionName || 'Korb bearbeiten',
        })}
      />
    </CollectionsStack.Navigator>
  );
};

const MainTabs = () => {
  return (
    <Tab.Navigator
      screenOptions={({ route }) => ({
        tabBarIcon: ({ focused, color, size }) => {
          let iconName;

          if (route.name === 'Einkaufen') {
            iconName = focused ? 'cart' : 'cart-outline';
          } else if (route.name === 'Läden') {
            iconName = focused ? 'business' : 'business-outline';
          } else if (route.name === 'Artikel') {
            iconName = focused ? 'list' : 'list-outline';
          } else if (route.name === 'Körbe') {
            iconName = focused ? 'basket' : 'basket-outline';
          } else if (route.name === 'Profil') {
            iconName = focused ? 'person' : 'person-outline';
          }

          return <Ionicons name={iconName} size={size} color={color} />;
        },
        tabBarActiveTintColor: '#2E7D32',
        tabBarInactiveTintColor: 'gray',
        headerStyle: {
          backgroundColor: '#2E7D32',
        },
        headerTintColor: '#fff',
        headerTitleStyle: {
          fontWeight: 'bold',
        },
      })}
    >
      <Tab.Screen 
        name="Einkaufen" 
        component={ShoppingStackNavigator}
        options={{
          headerShown: false, // Header wird vom Stack Navigator gehandhabt
        }}
      />
      <Tab.Screen 
        name="Läden" 
        component={StoresScreen}
        options={({ navigation }) => ({
             headerTitle: 'Läden',
          headerRight: () => (
            <TouchableOpacity 
              onPress={() => {
                // Öffne das Modal zum Erstellen eines neuen Ladens
                // Das wird über einen Event oder Context gehandhabt
                navigation.setParams({ openCreateModal: true });
              }}
              style={{ marginRight: 15 }}
            >
              <Ionicons 
                name="add-circle-outline" 
                size={28} 
                color="#fff"
              />
            </TouchableOpacity>
          ),
        })}
      />
      <Tab.Screen 
        name="Artikel" 
        component={ArticlesScreen}
        options={({ navigation }) => ({
             headerTitle: 'Artikel',
          headerRight: () => (
            <TouchableOpacity 
              onPress={() => {
                // Öffne das Modal zum Erstellen eines neuen Artikels
                // Das wird über einen Event oder Context gehandhabt
                navigation.setParams({ openCreateModal: true });
              }}
              style={{ marginRight: 15 }}
            >
              <Ionicons 
                name="add-circle-outline" 
                size={28} 
                color="#fff"
              />
            </TouchableOpacity>
          ),
        })}
      />
      <Tab.Screen 
        name="Körbe" 
        component={CollectionsStackNavigator}
        options={{
          headerShown: false, // Header wird vom Stack Navigator gehandhabt
        }}
      />
      <Tab.Screen 
        name="Profil" 
        component={ProfileScreen}
        options={{
          headerTitle: 'Profil',
        }}
      />
    </Tab.Navigator>
  );
};

export default MainTabs;

